var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "800",
      "title": `${_vm.openedTankRental ? '编辑' : '新增'}储罐借用`
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "addForm"
  }, [_c('FormItem', {
    attrs: {
      "label": "客户",
      "prop": "customer"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "filterable": "",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.customerLoading,
      "placeholder": "请填写客户名字后选择"
    },
    model: {
      value: _vm.formItem.customer,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "customer", $$v);
      },
      expression: "formItem.customer"
    }
  }, _vm._l(_vm.customerList, function (customer) {
    return _c('Option', {
      key: customer._id,
      staticStyle: {
        "width": "350px"
      },
      attrs: {
        "value": customer._id,
        "remote": ""
      }
    }, [_vm._v(_vm._s(customer.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "公司",
      "prop": "company"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "350px"
    },
    model: {
      value: _vm.formItem.company,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "company", $$v);
      },
      expression: "formItem.company"
    }
  }, _vm._l(_vm.companyList, function (company) {
    return _c('Option', {
      key: company._id,
      staticStyle: {
        "width": "350px"
      },
      attrs: {
        "value": company._id
      }
    }, [_vm._v(_vm._s(company.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "合同编号",
      "prop": "remark"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "输入合同编号..."
    },
    model: {
      value: _vm.formItem.contractId,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "contractId", $$v);
      },
      expression: "formItem.contractId"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "合同状态",
      "prop": "status"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "300px"
    },
    model: {
      value: _vm.formItem.status,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "status", $$v);
      },
      expression: "formItem.status"
    }
  }, _vm._l(_vm.statusList, function (status) {
    return _c('Option', {
      key: status.value,
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "value": status.value
      }
    }, [_vm._v(_vm._s(status.label))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "合同开始日期",
      "prop": "contractStartedAt"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择合同开始日期"
    },
    model: {
      value: _vm.formItem.contractStartedAt,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "contractStartedAt", $$v);
      },
      expression: "formItem.contractStartedAt"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "合同结束日期",
      "prop": "contractEndedAt"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择合同结束日期"
    },
    model: {
      value: _vm.formItem.contractEndedAt,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "contractEndedAt", $$v);
      },
      expression: "formItem.contractEndedAt"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "placeholder": "输入备注..."
    },
    model: {
      value: _vm.formItem.remark,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "remark", $$v);
      },
      expression: "formItem.remark"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "doc文件",
      "prop": "doc"
    }
  }, [_c('input', {
    ref: "docFilElem",
    staticClass: "add-file-right-input",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": "multiplt",
      "accept": ".docx,.doc"
    },
    on: {
      "change": function ($event) {
        return _vm.getDocFile($event);
      }
    }
  }), _vm._l(_vm.docFileList, function (file, index) {
    return _c('div', {
      key: file._id,
      attrs: {
        "value": file._id
      }
    }, [_c('div', {
      staticClass: "fileList-item"
    }, [_c('div', {
      staticClass: "fileList-item-name"
    }, [_vm._v(" " + _vm._s(file.fileName ? file.fileName : file.name) + " ")]), _vm.openedTankRental ? _c('div', {
      staticClass: "fileList-item-down",
      on: {
        "click": function ($event) {
          return _vm.downFileItem(file);
        }
      }
    }, [_vm._v(" 下载 ")]) : _vm._e(), _c('div', {
      staticClass: "fileList-item-del",
      on: {
        "click": function ($event) {
          return _vm.delFileItem(index);
        }
      }
    }, [_vm._v(" 删除 ")])])]);
  }), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.openF('docFilElem');
      }
    }
  }, [_vm._v("选择文件")])], 2), _c('FormItem', {
    attrs: {
      "label": "pdf文件",
      "prop": "pdf"
    }
  }, [_c('input', {
    ref: "pdfFilElem",
    staticClass: "add-file-right-input",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": "multiplt",
      "accept": ".pdf"
    },
    on: {
      "change": function ($event) {
        return _vm.getPdfFile($event);
      }
    }
  }), _vm._l(_vm.pdfFileList, function (file, index) {
    return _c('div', {
      key: file._id,
      attrs: {
        "value": file._id
      }
    }, [_c('div', {
      staticClass: "fileList-item"
    }, [_c('div', {
      staticClass: "fileList-item-name"
    }, [_vm._v(" " + _vm._s(file.fileName ? file.fileName : file.name) + " ")]), _vm.openedTankRental ? _c('div', {
      staticClass: "fileList-item-down"
    }, [_vm._v(" 下载 ")]) : _vm._e(), _c('div', {
      staticClass: "fileList-item-del",
      on: {
        "click": function ($event) {
          return _vm.delFileItem(index);
        }
      }
    }, [_vm._v(" 删除 ")])])]);
  }), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.openF('pdfFilElem');
      }
    }
  }, [_vm._v("选择文件")])], 2), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _c('div', {
    staticClass: "storagetank"
  }, [_c('h3', [_vm._v("储罐")]), _c('FormItem', {
    attrs: {
      "prop": "storageTank"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "filterable": "",
      "remote-method": _vm.getStorageTankListMethod,
      "loading": _vm.storageTankLoading,
      "placeholder": "搜索储罐"
    },
    on: {
      "on-change": _vm.addTank
    },
    model: {
      value: _vm.selectedTank,
      callback: function ($$v) {
        _vm.selectedTank = $$v;
      },
      expression: "selectedTank"
    }
  }, _vm._l(_vm.storageTankList, function (storageTank) {
    return _c('Option', {
      key: storageTank._id,
      staticStyle: {
        "width": "350px",
        "display": "flex",
        "justify-content": "space-between"
      },
      attrs: {
        "value": storageTank._id,
        "label": storageTank.name,
        "remote": ""
      }
    }, [_c('div', [_vm._v(_vm._s(storageTank.name))]), _c('div', [_vm._v("添加")])]);
  }), 1)], 1), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.tankTable,
      "height": _vm.tableHeight
    },
    scopedSlots: _vm._u([{
      key: "deleteBtn",
      fn: function (_ref) {
        var row = _ref.row;
        return [_c('Icon', {
          staticClass: "deleteBtn",
          attrs: {
            "type": "ios-remove-circle-outline"
          },
          on: {
            "click": function ($event) {
              return _vm.removeTank(row._id);
            }
          }
        })];
      }
    }])
  })], 1)], 1)])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }